exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../../../img_zeus/FONDO50.png"));

// Module
exports.push([module.id, ".container-courses{\n    height: 100%;\n    background-image: url(" + ___CSS_LOADER_URL___0___ + ");\n}\n.img-course-index{\n    max-width: 500px;\n    max-height: 500px;\n\n}\n/* //////////////////DEVICE MOBILE/////////////////////////// */\n@media (max-width: 414px) and (max-height: 812px) {\n.container-course-index img{\n    width: 100%;\n\n}\n}", ""]);

